import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";
import queryString from "querystring";


let redux = reduxCreator.type('FORUM_BREADCRUMBS').plugin(axiosPlugin, {template: "array"});

let fetchForumBreadcrumbsAction = redux.fetchActionGet();

export const fetchForumBreadcrumbs = (forumId, query = {}) => fetchForumBreadcrumbsAction(`/forums/${forumId}/breadcrumbs?${queryString.stringify(query)}`);
export const resetForumBreadcrumbs = () => redux.actions.reset();

export const forumBreadcrumbs = redux.reducer();
